import { postToApi } from './axios';

/**
 * @typedef {Object} ImproveItemInput
 * @property {string} key
 * @property {string} text
 * @property {string} [context]
 * @property {string} [instruction] Indicación libre para guiar la corrección (regeneración).
 */

/**
 * @typedef {Object} ImproveItemResult
 * @property {string} key
 * @property {string} original
 * @property {string} improved
 * @property {boolean} changed
 */

/**
 * Mejora redacción/ortografía de una lista de textos. Best-effort: el backend
 * nunca falla el flujo; ante error devuelve los originales con changed:false.
 * @param {ImproveItemInput[]} items
 * @returns {Promise<{ items: ImproveItemResult[], mock: boolean }>}
 */
export const improveTexts = async (items) => {
  const response = await postToApi('/ai/improve-texts', { items });
  const data = response?.data || response;
  return {
    items: Array.isArray(data?.items) ? data.items : [],
    mock: Boolean(data?.mock),
  };
};
